import React from 'react';
import DownloadLink from './DownloadLink';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function ArchivedActions({ telehealth }) {
  return <div>
    <DownloadLink telehealth={telehealth} small />
    &nbsp;
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/telehealth/${telehealth.id}`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
  </div>
}